import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  FORGOT_PASSWORD,
  GET_LOGGED_IN_USER_DETAILS,
  LOGIN,
  NEW_USER_RESET_PASSWORD,
  RESET_PASSWORD,
  SIGNUP,
  VALIDATE_UUID,
  VERIFY_OTP,
  VERIFY_EMAIL,
  RESEND_VERIFICATION_LINK,
  CHECK_VERIFICATION_STATUS,
  SAVE_COMPANY_INFO
} from "../../helpers/url_helper";
import { get, patch, post, put } from "../../helpers/api_helper";

export const signUp = createAsyncThunk(SIGNUP, async (payload) => {
  const response = await post(SIGNUP, payload);
  return response;
});
export const verifyEmail = createAsyncThunk(VERIFY_EMAIL, async (payload) => {
  const response = await post(VERIFY_EMAIL, payload);
  return response;
});
export const resendVerificationLink = createAsyncThunk(RESEND_VERIFICATION_LINK, async (payload) => {
  const response = await post(RESEND_VERIFICATION_LINK, payload);
  return response;
});
export const checkVerificationStatus = createAsyncThunk(
  CHECK_VERIFICATION_STATUS,
  async (payload) => {
    const response = await get(`${CHECK_VERIFICATION_STATUS}${payload.userId}`);
    return response;
  }
);
export const saveCompanyInfo = createAsyncThunk(
  SAVE_COMPANY_INFO,
  async (payload) => {
    const response = await put(SAVE_COMPANY_INFO,payload);
    return response;
  }
);
export const getCompanyInfo = createAsyncThunk(
  SAVE_COMPANY_INFO,
  async (payload) => {
    const response = await put(SAVE_COMPANY_INFO,payload);
    return response;
  }
);

export const login = createAsyncThunk(LOGIN, async (payload) => {
  const response = await post(LOGIN, payload);
  return response;
});

export const forgotPassword = createAsyncThunk(
  FORGOT_PASSWORD,
  async (payload) => {
    const response = await post(FORGOT_PASSWORD, payload);
    return response;
  }
);

export const verifyOtp = createAsyncThunk(VERIFY_OTP, async (payload) => {
  const response = await post(VERIFY_OTP, payload);
  return response;
});

export const resetPassword = createAsyncThunk(
  RESET_PASSWORD,
  async (payload) => {
    const response = await patch(RESET_PASSWORD, payload);
    return response;
  }
);

export const validateUUID = createAsyncThunk(VALIDATE_UUID, async (payload) => {
  const response = await post(VALIDATE_UUID, payload);
  return response;
});

export const resetNewPassword = createAsyncThunk(
  NEW_USER_RESET_PASSWORD,
  async (payload) => {
    const response = await patch(NEW_USER_RESET_PASSWORD, payload);
    return response;
  }
);

export const getAdminUserDetails = createAsyncThunk(
  GET_LOGGED_IN_USER_DETAILS,
  async (payload) => {
    const response = await get(GET_LOGGED_IN_USER_DETAILS);
    return response;
  }
);
